var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8636 15.6376H6.9091C6.14539 15.6376 5.76354 15.6376 5.47184 15.7862C5.21526 15.917 5.00665 16.1256 4.87591 16.3822C4.72728 16.6739 4.72728 17.0557 4.72728 17.8194V29.274M23.1364 15.6376H27.0909C27.8546 15.6376 28.2365 15.6376 28.5282 15.7862C28.7848 15.917 28.9934 16.1256 29.1241 16.3822C29.2727 16.6739 29.2727 17.0557 29.2727 17.8194V29.274M23.1364 29.274V9.09215C23.1364 7.56474 23.1364 6.80103 22.8391 6.21763C22.5776 5.70446 22.1604 5.28724 21.6473 5.02577C21.0639 4.72852 20.3002 4.72852 18.7727 4.72852H15.2273C13.6999 4.72852 12.9362 4.72852 12.3528 5.02577C11.8396 5.28724 11.4224 5.70446 11.1609 6.21763C10.8636 6.80103 10.8636 7.56474 10.8636 9.09215V29.274M30.6364 29.274H3.36365M15.6364 10.1831H18.3636M15.6364 15.6376H18.3636M15.6364 21.0922H18.3636",
    stroke: "#379E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.abc0ca2d2d58860bed6b5328f9fe166d.svg";
export { ForwardRef as ReactComponent };